import * as _ from 'lodash';

import Node from './Node';
import ValueNode from './ValueNode';
import TextType from './TextType';

abstract class CollectionNode extends ValueNode<Node[]> {

	public toText (textType = TextType.PLAIN) {
		return this.getTextPrefix(textType) + this.getValue().map(value => value.toText(textType)).join(this.getTextInfix(textType)) + this.getTextPostfix(textType);
	}

	protected getNormalizedElements () {
		return _.sortBy(this.getValue().map(element => element.normalized()), element => element.toText());
	}

	protected abstract getTextPrefix (textType?: TextType): string;

	protected getTextInfix (textType?: TextType) {
		return ', ';
	}

	protected abstract getTextPostfix (textType?: TextType): string;
}

export default CollectionNode;


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/CollectionNode.ts